import css from "./AiAssistantIcon.module.scss";

const AiAssistantIcon = ({ className = "" }) => (
  <span className={`${css.orb} ${className}`} aria-hidden="true">
    <span className={css.core} />
    <span className={`${css.ring} ${css.ringOne}`} />
    <span className={`${css.ring} ${css.ringTwo}`} />
  </span>
);

export default AiAssistantIcon;
